import React from 'react';
import classnames from 'classnames';

interface TooltipSpotProps {
  attachPosition: string;
  top?: number | string;
  left?: number | string;
  right?: number | string;
  bottom?: number | string;
  onEnter?(): void;
}

export default class TooltipSpot extends React.Component<TooltipSpotProps> {
  render() {
    const { top, left, right, bottom, attachPosition, onEnter } = this.props;
    return (
      <div
        className={classnames('spot-container', attachPosition)}
        style={{ top, left, right, bottom }}
        onMouseEnter={onEnter}
      >
        <div className="spot" />
        <style jsx>{`
          .spot-container {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }

          .spot-container .spot {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: solid 2px #008eff;
            animation: SpotAnimation 1.5s infinite;
          }

          .spot-container.top {
            transform: translate(-50%, 0);
          }

          .spot-container.left {
            transform: translate(0, -50%);
          }

          .spot-container.right {
            transform: translate(0, -50%);
          }

          .spot-container.bottom {
            transform: translate(-50%, 0);
          }

          .spot-container.center {
            transform: translate(-50%, -50%);
          }

          @keyframes SpotAnimation {
            from {
              width: 0;
              height: 0;
              opacity: 0.8;
            }

            to {
              width: 40px;
              height: 40px;
              opacity: 0;
            }
          }
        `}</style>
      </div>
    );
  }
}
